import { create } from "zustand";
import type { ServiceCategoryType } from "@/features/permission";

export type CategoryFilter = ServiceCategoryType | "ALL";

interface SystemRoleStore {
  drawerOpen: boolean;
  editingRoleGuid: string | null;
  categoryFilter: CategoryFilter;
  deleteTargetGuid: string | null;

  openDrawerForAdd: () => void;
  openDrawerForEdit: (guid: string) => void;
  setEditingRoleGuid: (guid: string) => void;
  closeDrawer: () => void;

  setCategoryFilter: (c: CategoryFilter) => void;

  openDeleteFor: (guid: string) => void;
  closeDelete: () => void;
}

export const useSystemRoleStore = create<SystemRoleStore>((set) => ({
  drawerOpen: false,
  editingRoleGuid: null,
  categoryFilter: "ALL",
  deleteTargetGuid: null,

  openDrawerForAdd: () => set({ drawerOpen: true, editingRoleGuid: null }),
  openDrawerForEdit: (guid) =>
    set({ drawerOpen: true, editingRoleGuid: guid }),
  setEditingRoleGuid: (guid) => set({ editingRoleGuid: guid }),
  closeDrawer: () => set({ drawerOpen: false, editingRoleGuid: null }),

  setCategoryFilter: (categoryFilter) => set({ categoryFilter }),

  openDeleteFor: (guid) => set({ deleteTargetGuid: guid }),
  closeDelete: () => set({ deleteTargetGuid: null }),
}));
